import { Link } from 'react-router-dom'
import IcStarImage from 'assets/images/ic-star-light.svg'
import { Button } from 'avo-ui'
import icEyeOpen from 'assets/images/ic-eye-open.svg'

export const SORT_PRODUCT_REVIEW = [
    {
        label: 'Sort By Rating Desc',
        key: 'rating-desc',
        name: 'sort-all-review',
    },
    {
        label: 'Sort By Rating Asc',
        key: 'rating-asc',
        name: 'sort-all-review',
    },
    {
        label: 'Sort By Created At Asc',
        key: 'created_at-asc',
        name: 'sort-all-review',
    },
    {
        label: 'Sort By Created At Desc',
        key: 'created_at-desc',
        name: 'sort-all-review',
    },
]

export const TABLE_PRODUCT_REVIEW = {
    name: 'Comment',
    column: [
        {
            name: 'Nama Product',
            key: 'product_name',
            render: ({ item }) => (
                <div className={'flex flex-row items-center space-x-4'}>
                    <img src={item.image_url} alt={item?.image_alt_text} className={'w-8 h-8'} />
                    <p>{item.name}</p>
                </div>
            ),
        },
        {
            name: 'Total Rating',
            key: 'total_rating',
            render: ({ value }) => (
                <div className={'flex flex-row space-x-1'}>
                    <img src={IcStarImage} alt={'star'} className={'w-3'} />
                    <p className={'font-bold'}>{value}</p>
                </div>
            ),
        },
        {
            name: 'Total Review',
            key: 'total_review',
            render: ({ value }) => <p>{value} Reviews</p>,
        },
        {
            name: '',
            key: 'id',
            render: ({ value }) => (
                <Link to={`detail?productId=${value}&skin_type=normal`}>
                    <Button type={'outline'} icon={icEyeOpen} title={'Detail'} onClick={() => {}} />
                </Link>
            ),
        },
    ],
}
